import React from 'react';
import { CheckIcon } from 'lucide-react';
const capabilities = ['Data migration planning and execution', 'Custom ETL (Extract, Transform, Load) pipelines', 'Database schema design and optimization', 'SQL and NoSQL expertise', 'Data validation and integrity checks', 'Automated backup and recovery systems'];
export function Capabilities() {
  return <section className="py-16" data-id="element-416">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-417">
        <div className="scroll-fade-in-up" data-id="element-418">
          <div className="bg-surface rounded-xl p-8 md:p-12" data-id="element-419">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-420">
              Key Capabilities
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-421">
              We specialize in designing and implementing robust database
              architectures that ensure data integrity, security, and high
              performance. Our expertise extends to complex data migrations,
              optimizing existing systems, and building custom ETL pipelines
              tailored to your specific business needs.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-422">
              {capabilities.map((cap, i) => <li key={i} className="flex items-start" data-id="element-423">
                  <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-424" />
                  <span className="text-gray-700" data-id="element-425">{cap}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}